import { EMAIL_LOCAL_PART_MAX_LENGTH } from '@promo/shared';

export const useEmailValidation = () => {
  const validateEmail = (username: string): string | null => {
    // Empty check
    if (!username) return 'Email is required';

    if (username.length > EMAIL_LOCAL_PART_MAX_LENGTH) {
      return `Email username must be ${EMAIL_LOCAL_PART_MAX_LENGTH} characters or fewer`;
    }

    // Username format (no @ symbol needed)
    if (!/^[a-zA-Z0-9.+-]+$/.test(username)) {
      return 'Only letters, numbers, dots, plus, and dash allowed';
    }

    return null;
  };

  const getFullEmail = (username: string): string => {
    return `${username}@tebra.com`;
  };

  return { validateEmail, getFullEmail };
};
